module.exports = __webpack_public_path__ + "static/img/14000144.fd7b968a.png";